
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 22.5a.75.75 0 010-1.5c4.963 0 9-4.037 9-9s-4.037-9-9-9c-4.546 0-8.361 3.447-8.925 7.865L6.22 9.22c.141-.142.33-.22.53-.22s.389.078.53.22c.142.141.22.33.22.53s-.078.389-.22.53l-3 3a.763.763 0 01-.246.164l-.027.01a.738.738 0 01-.517-.001l-.022-.008a.732.732 0 01-.249-.165l-2.999-3C.078 10.139 0 9.95 0 9.75s.078-.389.22-.53C.361 9.078.55 9 .75 9s.389.078.53.22l1.771 1.771C3.564 5.685 8.084 1.5 13.5 1.5 19.29 1.5 24 6.21 24 12s-4.71 10.5-10.5 10.5z"}}),_c('path',{attrs:{"d":"M8.52 18a.752.752 0 01-.563-1.246 7.386 7.386 0 016.01-2.49 7.338 7.338 0 015.076 2.49A.752.752 0 0118.48 18a.75.75 0 01-.563-.254 5.846 5.846 0 00-4.428-1.996 5.872 5.872 0 00-4.407 1.996.749.749 0 01-.562.254z"}}),_c('path',{attrs:{"d":"M13.5 15A4.505 4.505 0 019 10.5C9 8.019 11.019 6 13.5 6S18 8.019 18 10.5 15.981 15 13.5 15zm0-7.5c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"}})])
          )
        }
      }
    